/** @format */

import React, { Suspense } from 'react';

import flags from './flags';

const Flag = ({ countryCode }) => {
  if (countryCode) {
    const CountryFlag = flags[countryCode];

    return (
      <div className='flag'>
        <Suspense fallback={<></>}>
          <CountryFlag />
        </Suspense>
      </div>
    );
  }

  return <></>;
};

export default Flag;
